import './testAttachmentsComponent.scss'
import FormTitleWithNavigationBack
    from "../../../../shared/components/form-title-with-navigation-back/FormTitleWithNavigationBack";
import InputComponent from "../../../../shared/components/core/input/InputComponent";
import ButtonComponent from "../../../../shared/components/core/button/ButtonComponent";
import StatusCardComponent from "../../../../shared/components/status-card/statusCardComponent";
import {CommonService} from "../../../../shared/services";
import FeedbackComponent from "../../../../shared/components/feedback/feedbackComponent";
import React, {useCallback, useEffect, useRef, useState} from "react";
import {IAPIResponseType} from "../../../../shared/models/api.model";
import {ImageConfig} from "../../../../constants";
import _ from "lodash";
import FilePreviewerComponent from "../../../../shared/components/file-previewer/filePreviewerComponent";
import DialogComponent from "../../../../shared/components/dialog/dialogComponent";
import AttachmentViewDownloadComponent
    from "../../../../shared/components/core/attachment-view-download/attachmentViewDownloadComponent";
import PdfPreviewComponent from "../../../../shared/components/pdf-preview/pdfPreviewComponent";
import ErrorComponent from "../../../../shared/components/form-controls/error/errorComponent";

interface TestAttachmentsComponentProps {
    next: Function;
    cancel: Function;
    prev: Function;
    testID: number;
}

const TestAttachmentsComponent = (props: TestAttachmentsComponentProps) => {
        const {next, cancel, testID,prev} = props;
        // const [isAttachmentListLoading, setIsAttachmentListLoading] = useState<boolean>(false);
        const [isAttachmentListLoaded, setIsAttachmentListLoaded] = useState<boolean>(false);
        const [isAttachmentListLoadingFailed, setIsAttachmentListLoadingFailed] = useState<boolean>(false);
        const [attachmentList, setAttachmentList] = useState<any[]>([]);

        const [attachmentTitle, setAttachmentTitle] = useState<string>("");
        const attachmentFileRef = useRef<HTMLInputElement | null>(null);
        const [showAttachmentPreviewDialog, setShowAttachmentPreviewDialog] = useState<boolean>(false);

        const [isAttachmentBeingUploaded, setIsAttachmentBeingUploaded] = useState<boolean>(false);
        const [attachmentFile, setAttachmentFile] = useState<any | undefined>(undefined);
        const [isNewAttachment, setNewAttachment] = useState<boolean>(false)
        const [isContinueVisible, setIsContinueVisible] = useState<boolean>(false);

          const getAttachmentList = useCallback(() => {
            const payload = {};
            // setIsAttachmentListLoading(true);
            setIsAttachmentListLoaded(false);
            setIsAttachmentListLoadingFailed(false);
            let attachmentList: any = {};
            CommonService._test.getTestAttachments(testID, payload)
                .then((response: IAPIResponseType<any>) => {
                    if (response?.success) {
                        attachmentList = response?.data;
                        setAttachmentList(attachmentList);
                    }
                    // setIsAttachmentListLoading(false);
                    setIsAttachmentListLoaded(true);
                    setIsAttachmentListLoadingFailed(false);
                })
                .catch((error: any) => {
                    // setIsAttachmentListLoading(false);
                    setIsAttachmentListLoaded(false);
                    setIsAttachmentListLoadingFailed(true);
                });
        }, [testID]);

        const handleAttachmentSuccess = useCallback((response: any) => {
            setAttachmentList((oldState: any) => {
                if (oldState?.length > 0) {
                    return [response.data, ...oldState]
                } else {
                    return [response.data]
                }
            })
            setIsAttachmentBeingUploaded(false);
            setAttachmentTitle("");
            setAttachmentFile(undefined);
            setShowAttachmentPreviewDialog(false);
        }, []);

        const onAttachmentSubmit = useCallback(() => {
            const formData = new FormData();
            if (attachmentFile) {
                formData.append('image', attachmentFile);
            }
            formData.append('attachmentName', attachmentTitle);
            setIsAttachmentBeingUploaded(true);
            CommonService._test.addTestAttachment(testID, formData)
                .then((response: IAPIResponseType<any>) => {
                    handleAttachmentSuccess(response);
                })
                .catch((error: any) => {
                    CommonService._alert.showToast(error?.message || 'Error uploading panel attachment', "error");
                    setIsAttachmentBeingUploaded(false);
                })
        }, [handleAttachmentSuccess, attachmentTitle, attachmentFile, testID]);


        const handleAttachmentUpload = useCallback((event: any) => {
            const file = event?.target?.files[0];
            const maxAllowedSize = 5 * 1024 * 1024;
            if (event?.target?.files[0].size > maxAllowedSize) {
                CommonService._alert.showToast('File size should be under 5MB.', "error");
                event.target.value = '';
                return;
            }
            event.target.value = null;
            event.target.files = null;
            setIsContinueVisible(true);
            setShowAttachmentPreviewDialog(true);
            setAttachmentFile(file);
            setNewAttachment(true);
        }, []);

        const removeAttachment = useCallback((attachmentId: any) => {
            const payload = {};
            CommonService._test.deleteTestAttachment(testID, attachmentId, payload)
                .then((response: IAPIResponseType<any>) => {
                    CommonService._alert.showToast(response?.message || 'attachments has been removed', "success");
                    setAttachmentList((oldState: any) => {
                        const updatedList = _.cloneDeep(oldState);
                        const index = updatedList.findIndex((item: any) => item.id === attachmentId);
                        updatedList.splice(index, 1);
                        return updatedList;
                    })
                })
                .catch((error: any) => {
                    CommonService._alert.showToast(error?.message || 'Error deleting attachment', "error");
                })
        }, [testID]);

        const handleAttachmentRemove = useCallback((id: any) => {
            CommonService.openConfirmationDialog({
                confirmationTitle: 'Please confirm!',
                confirmationSubTitle: 'Are you sure you want to delete this attachment?',
                disableEscKeyClose: false,
                disableBackdropClose: true,
                imagePath: `${ImageConfig.DeleteImage}`,
                direction: "up",
                yes: {
                    text: "Confirm",
                    color: "primary"
                },
                no: {
                    text: "Cancel",
                    color: "primary"
                }
            })
                .then(() => {
                    removeAttachment(id);
                })
                .catch(() => {
                })
        }, [removeAttachment]);

        useEffect(() => {
            getAttachmentList();
        }, [testID, getAttachmentList]);


        return (
            <div className="test-order-attachment-screen screen t-form-screen">
                <FormTitleWithNavigationBack
                    title={'Attachments'}
                    tooltipData={"This includes the necessary information to contact the test. Ensure that the inputs provided are accurate."}
                    handleClick={prev}
                />
                <div className="t-form attachments-with-title-wrapper">
                    {/* eslint-disable-next-line no-script-url */}
                    <form noValidate={true} action={'javascript:void'}>
                        <div className="t-form-controls-wrapper">
                            <div className="attachment-input-wrapper">
                                <div className={'attachment-input-section'}>
                                    <InputComponent
                                        type={"text"}
                                        name={"title"}
                                        label={"Attachment Name"}
                                        placeholder={"Enter Attachment Name"}
                                        value={attachmentTitle}
                                        required={false}
                                        onChange={(value: any) => {
                                            setAttachmentTitle(value.replace(/\s/g, ''));
                                        }}
                                    />
                                    {
                                        attachmentTitle.length > 100 &&
                                        <ErrorComponent errorText={'Attachment name should be less than 100 characters'} />
                                    }
                                </div>
                                <input type={"file"}
                                       className={"display-none"}
                                       ref={attachmentFileRef}
                                       accept={"image/jpeg,image/gif,image/png,application/pdf,image/x-eps"}
                                       onChange={(event) => {
                                           handleAttachmentUpload(event);
                                       }}
                                />
                                <ButtonComponent
                                    className="attachment-upload-button"
                                    disabled={attachmentTitle?.length === 0 || attachmentTitle?.length > 100}
                                    color={"secondary"}
                                    variant={"contained"}
                                    fullWidth={false}
                                    size={'large'}
                                    isLoading={isAttachmentBeingUploaded}
                                    handleClick={() => {
                                        attachmentFileRef.current?.click()
                                    }}>
                                    Choose
                                </ButtonComponent>
                            </div>

                            <div className="attachment-list-section">
                                {/*{isAttachmentListLoading &&*/}
                                {/*    <LottieFileGenarationComponent*/}
                                {/*        loop={true}*/}
                                {/*        autoplay={true}*/}
                                {/*        animationData={ImageConfig.LoadingLottieFile}/>*/}
                                {/*}*/}
                                {isAttachmentListLoadingFailed &&
                                <StatusCardComponent title={'failed to load attachment list'}/>
                                }
                                {isAttachmentListLoaded && <>
                                    {attachmentList?.length > 0 &&
                                    <div className="attachment-list-wrapper">
                                        {attachmentList?.map((attachment: any) =>
                                            <div key={CommonService.getUUID()}>
                                                <AttachmentViewDownloadComponent
                                                    attachment={attachment}
                                                    attachmentTitle={attachment.attachmentName}
                                                    showDeleteOption={true}
                                                    onClick={(id: any) => handleAttachmentRemove(id)}
                                                />
                                            </div>
                                        )}
                                    </div>
                                    }
                                    {attachmentList?.length === 0 &&
                                    <FeedbackComponent className={'width-50'}>No attachment have been uploaded.</FeedbackComponent>
                                    }
                                </>
                                }
                            </div>
                        </div>
                        <div className='form-action-section'>
                            <ButtonComponent
                                type="button"
                                color={"primary"}
                                variant={"outlined"}
                                fullWidth={true}
                                disabled={isAttachmentBeingUploaded}
                                handleClick={cancel}
                            >
                                Close
                            </ButtonComponent>
                            <ButtonComponent

                                type="button"
                                color={"primary"}
                                variant={"contained"}
                                fullWidth={true}
                                disabled={isAttachmentBeingUploaded}
                                handleClick={next}
                            >
                                Submit
                            </ButtonComponent>
                        </div>
                    </form>x
                </div>

                <DialogComponent open={showAttachmentPreviewDialog}
                                 maxWidth={'sm'}
                                 title={attachmentTitle}
                                 isShowCancel={true}
                                 onClose={() => {
                                     setShowAttachmentPreviewDialog(false);
                                     setAttachmentTitle("");
                                 }}
                                 className={"attachment-preview-dialog"}>
                    <div className="attachment-preview-dialog-body" id="file_preview_component">
                        {attachmentFile && attachmentFile?.type === 'application/pdf' ?
                            <PdfPreviewComponent
                                attachmentFile={attachmentFile}
                                width="550"
                                height="500"
                                isFile={isNewAttachment}
                            />
                            :
                            <FilePreviewerComponent
                                attachmentFile={attachmentFile}
                                isFile={isNewAttachment}/>
                        }
                    </div>
                    {attachmentFile && <div className="uploaded-attachment-file-name">
                        <span className="font-weight-bold"> Uploaded File Name:</span>
                        <span>{attachmentFile?.name}</span>
                    </div>
                    }
                    <div className="attachment-preview-dialog-footer">
                        <ButtonComponent variant={"outlined"}
                                         id="cancel_btn"
                                         color={"primary"}
                                         fullWidth={true}
                                         disabled={isAttachmentBeingUploaded}
                                         handleClick={() => {
                                             attachmentFileRef.current?.click()
                                         }}
                        >
                            Re-upload
                        </ButtonComponent>&nbsp;
                        {
                            isContinueVisible &&
                            <ButtonComponent variant={"contained"}
                                             color={'primary'}
                                             id="continue_btn"
                                             fullWidth={true}
                                             isLoading={isAttachmentBeingUploaded}
                                             handleClick={onAttachmentSubmit}>
                                Continue
                            </ButtonComponent>
                        }
                    </div>
                </DialogComponent>

            </div>
        )
    }

;

export default TestAttachmentsComponent;
